module.exports = global["$"] = require("-!/srv/goalpes.com/releases/20250328132700/node_modules/babel-loader/lib/index.js??ref--10-0!./jquery.js");